import React, { useReducer } from 'react'
import { CheckContext } from '../context/useCheck'
import { checkReducer, initialState } from '../reducer/checkReducer'

/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: se crea checkProvider por cambio a useReducer + Context
 */

export const CheckProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(checkReducer, initialState)

  const value = { state, dispatch }

  return <CheckContext.Provider value={value}>{children}</CheckContext.Provider>
}
